/**
 * Wizard bundle entry point. Bundled by esbuild as a separate output
 * (public/assets/wizard.js) so the auth bundle stays focused on
 * sign-in/identity and CSP `'unsafe-inline'` can be dropped in Phase 6.
 */
import { initMigrationWizard } from './wizard.js';

function start(): void {
  try {
    initMigrationWizard();
  } catch (err) {
    // Mirror what the inline script effectively did: crash visibly in
    // the console so QA notices missing DOM ids instead of silently
    // leaving the wizard dead.
    console.error('[wizard] initialization failed', err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
